import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const SiteLogoContext = createContext();

export const SiteLogoProvider = ({ children }) => {
  const [logoUrl, setLogoUrl] = useState(null);
  const [darkLogoUrl, setDarkLogoUrl] = useState(null);
  const [siteName, setSiteName] = useState('PlanCity');
  const [loading, setLoading] = useState(true);

  const fetchSiteLogo = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/uploads/site-logo`);
      setLogoUrl(response.data.logo_url);
      setDarkLogoUrl(response.data.dark_logo_url || null);
      setSiteName(response.data.site_name || 'PlanCity');
    } catch (error) {
      console.error('Failed to fetch site logo:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSiteLogo();
  }, []);

  const updateLogo = (newLogoUrl) => {
    setLogoUrl(newLogoUrl);
  };

  const updateDarkLogo = (newDarkLogoUrl) => {
    setDarkLogoUrl(newDarkLogoUrl);
  };

  const resetLogo = () => {
    setLogoUrl(null);
  };

  const getFullLogoUrl = () => {
    if (!logoUrl) return null;
    if (logoUrl.startsWith('http')) return logoUrl;
    return `${API_URL}${logoUrl}`;
  };

  const getFullDarkLogoUrl = () => {
    if (!darkLogoUrl) return null;
    if (darkLogoUrl.startsWith('http')) return darkLogoUrl;
    return `${API_URL}${darkLogoUrl}`;
  };

  return (
    <SiteLogoContext.Provider value={{
      logoUrl,
      darkLogoUrl,
      siteName,
      loading,
      updateLogo,
      updateDarkLogo,
      resetLogo,
      refreshLogo: fetchSiteLogo,
      getFullLogoUrl,
      getFullDarkLogoUrl
    }}>
      {children}
    </SiteLogoContext.Provider>
  );
};

export const useSiteLogo = () => {
  const context = useContext(SiteLogoContext);
  if (!context) {
    throw new Error('useSiteLogo must be used within a SiteLogoProvider');
  }
  return context;
};
